import { render } from "./privacyBannerComponent.vue?vue&type=template&id=789fb728"
import script from "./privacyBannerComponent.vue?vue&type=script&lang=js"
export * from "./privacyBannerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__